import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener} from '@angular/core';
import {Router} from "@angular/router";
import {OptionService} from '../../services/option/option.service';
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {WordDispComponent} from './word-disp.component';
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";

@Component({
  selector: 'app-word-homonym-disp',
  template: `
    <article class="keyword">
      <table>
        <tr class="sub top">
          <td *ngFor="let cs of word.wordStruct"
              class="{{ GetSeungjoClass(cs) }}"></td>
        </tr>
        <tr class="main">
          <td *ngFor="let cs of word.wordStruct; let idx = index"
              class="{{ GetCharClass(cs) }} {{ GetHightlightClass(idx) }}">{{ GetCharTxt(cs) }}</td>
          <td *ngIf="word.idxHomonym > 0"
              class="idx-homonym">{{ word.idxHomonym }}</td>
        </tr>
        <tr class="sub bottom">
          <td *ngFor="let cs of word.wordStruct"></td>
        </tr>
      </table>
    </article>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WordHomonymDispComponent extends WordDispComponent {

  constructor(
    public router: Router,
    public dynamicSvc: DynamicComponentService,
    public lm: LayoutMgrService,
    protected cdRef: ChangeDetectorRef,
    protected option: OptionService,
    protected globalEventSvc: GlobalEventService,
  ) {
    super(router, dynamicSvc, lm, cdRef, option, globalEventSvc);
  }


  @HostListener('click', ['$event'])
  onClick($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (this.word?.id) {
      this.OpenMultiLink(this.word.id).subscribe(resultLinkPopup => {
        console.warn('OtherRegionDialectComponent.onClick() resultLinkPopup =', resultLinkPopup);
      });
    }
  }
}
